/* =========================================================================
   CIMENTO SKATE — página de produto
   Tamanho      a roupa abre SEM tamanho escolhido (product-info[data-tw-size="pending"], sections/main-product).
                Enquanto isso o COMPRAR já diz "Comprar · R$ X" e a barra fixa "Comprar" (30/set, aprovado pelo Pedro),
                mas o toque só rola até os tamanhos, mostra o aviso ("Falta o tamanho: escolha um aqui em cima.") e
                NADA vai pro carrinho (o formulário tem o id da 1ª variante, o M). O botão já nasce type="button" no
                Liquid (snippets/buy-buttons): sem este JS, o toque não envia nada. No 1º toque num tamanho vira
                "picked" e o botão volta a type="submit". A Rise redesenha o seletor a cada troca (sem nenhum
                marcado, snippets/product-variant-options) e escreve "Adicionar ao carrinho" no botão: aqui se marca
                de novo o tamanho escolhido e o texto volta pro data-tw-label ("Comprar · R$ X"). Depois do toque, a
                medida do tamanho aparece embaixo dos botões (data-tw-med, snippets/tw-medidas).
   Faixa do kit o link "Ver o que combina" vira âncora da faixa "Combina com" quando ela está na página.
   Barra fixa   celular: aparece sempre que o botão de compra NÃO está inteiro na tela, abaixo dela (chegada, 30/set) ou
                acima (já passou); some quando ele está inteiro à vista. Nunca os 2 botões à vista ao mesmo tempo.
                Computador: só depois que o botão passou (faixa no topo), como antes.
                O toque aciona o botão real (e cai na regra do tamanho acima). Esgotado: a barra copia o estado do
                botão real (desativada, "Esgotado").
   Sem dependências além do pubsub da Rise. Os textos em R$ chegam prontos do Liquid (data-*).
   ========================================================================= */
(function () {
  const SIZE = '[data-tw-size]'; // fieldset do tamanho (snippets/product-variant-picker)
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desk = window.matchMedia('(min-width: 990px)'); // mesmo corte do assets/casa.css (faixa no topo)

  const infoOf = (el) => (el && el.closest ? el.closest('product-info') : null);
  const isPending = (info) => !!info && info.dataset.twSize === 'pending';

  /* Barra fixa: copia o estado do botão real. Esgotado/indisponível: desativada com o mesmo texto;
     à venda: "Comprar" (data-tw-label), com o tamanho depois do toque num deles ("Comprar · M") */
  function syncSticky(info) {
    const bar = document.getElementById('StickyAtc-' + info.dataset.section);
    const btn = bar && bar.querySelector('.rx-sticky__button');
    if (!btn) return;
    const real = document.getElementById('ProductSubmitButton-' + info.dataset.section);
    const off = !!real && real.hasAttribute('disabled');
    btn.disabled = off;
    if (off) {
      const t = real.querySelector('span');
      btn.textContent = (t && t.textContent.trim()) || 'Esgotado';
      return;
    }
    if (!btn.dataset.twLabel) return;
    // Com tamanho escolhido, a barra confirma qual: "Comprar · M" (caixa-alta no CSS)
    const size = info.twSizeValue;
    btn.textContent = !isPending(info) && size ? btn.dataset.twLabel + ' · ' + size : btn.dataset.twLabel;
  }

  /* Botão de compra de volta a submit (o Liquid entrega type="button" enquanto o tamanho está pendente) */
  function armSubmit(info) {
    const real = document.getElementById('ProductSubmitButton-' + info.dataset.section);
    if (real && real.type !== 'submit') real.type = 'submit';
  }

  /* Medida do tamanho escolhido, lida do data-tw-med (snippets/tw-medidas, fonte única):
     "G: 57 cm de largura · 73 cm de comprimento (aprox.)". Sem tabela: vazio. */
  function showMed(fs, value) {
    const out = fs && fs.querySelector('.tw-size__med');
    if (!out) return;
    const row = (fs.dataset.twMed || '')
      .split(',')
      .map((l) => l.split('|'))
      .find((c) => c[0] === value);
    out.textContent = row ? value + ': ' + row[1] + ' cm de largura · ' + row[2] + ' cm de comprimento (aprox.)' : '';
  }

  /* Aviso do tamanho: o texto é apagado e reescrito a cada toque (role="alert"), senão o leitor de tela não lê de
     novo no 2º toque. Fica numa faixa de altura reservada: não empurra o botão. */
  let warnTimer;
  function setWarn(fs, on) {
    const warn = fs && fs.querySelector('.tw-size__warn');
    const txt = warn && warn.querySelector('.tw-size__warn-txt');
    if (!txt) return;
    clearTimeout(warnTimer);
    txt.textContent = '';
    warn.classList.toggle('is-on', on);
    if (on) warnTimer = setTimeout(() => (txt.textContent = 'Falta o tamanho: escolha um aqui em cima.'), 120);
  }

  /* Pede o tamanho: rola até os botões, mostra o aviso e põe o foco no 1º tamanho (sem marcar) */
  function askSize(info) {
    const fs = info.querySelector(SIZE);
    if (!fs) return;
    showMed(fs, null);
    setWarn(fs, true);
    fs.classList.remove('tw-size--ask');
    void fs.offsetWidth; // reinicia a animação do aviso a cada toque
    fs.classList.add('tw-size--ask');
    fs.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
    const first = fs.querySelector('input[type="radio"]');
    if (first) first.focus({ preventScroll: true });
  }

  /* COMPRAR (type="button") sem tamanho: o toque pede o tamanho */
  document.addEventListener('click', (e) => {
    const btn = e.target && e.target.closest ? e.target.closest('button[name="add"]') : null;
    if (!btn || btn.type === 'submit') return;
    const info = infoOf(btn);
    if (!isPending(info)) return;
    e.preventDefault();
    askSize(info);
  });

  /* Segunda trava: se algum envio escapar com o tamanho pendente, segura ANTES do product-form da Rise */
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      const info = infoOf(form);
      if (!isPending(info) || !form.matches('form[data-type="add-to-cart-form"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      askSize(info);
    },
    true
  );

  /* Toque num tamanho: sai do pendente, guarda o valor (a Rise vai redesenhar o seletor) */
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (!input || input.type !== 'radio' || !input.closest || !input.closest(SIZE)) return;
    const info = infoOf(input);
    if (!info) return;
    info.dataset.twSize = 'picked';
    info.twSizeValue = input.value;
    armSubmit(info);
    const fs = input.closest(SIZE);
    fs.classList.remove('tw-size--ask');
    setWarn(fs, false);
    showMed(fs, input.value);
    syncSticky(info);
  });

  /* Depois que a Rise troca a variante: marca de novo o tamanho e devolve o texto do botão */
  function onVariantChange({ data }) {
    if (!data || !data.sectionId) return;
    const info = document.querySelector('product-info[data-section="' + data.sectionId + '"]');
    if (!info || info.twSizeValue == null) return;

    // o seletor novo entra ANTES do antigo (que some em 500 ms): o 1º variant-selects é o novo
    const fs = info.querySelector('variant-selects ' + SIZE);
    if (fs && !fs.querySelector('input:checked')) {
      const input = Array.from(fs.querySelectorAll('input[type="radio"]')).find((i) => i.value === info.twSizeValue);
      if (input) input.checked = true;
    }
    if (fs) showMed(fs, info.twSizeValue);

    armSubmit(info);
    const btn = document.getElementById('ProductSubmitButton-' + data.sectionId);
    const label = btn && btn.querySelector('span');
    if (btn && label && !btn.hasAttribute('disabled') && data.variant) {
      const src = data.html && data.html.getElementById('ProductSubmitButton-' + data.sectionId);
      if (src && src.dataset.twLabel) btn.dataset.twLabel = src.dataset.twLabel;
      if (btn.dataset.twLabel) label.textContent = btn.dataset.twLabel;
    }
    syncSticky(info);
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  /* Pendente de verdade: o navegador pode devolver um tamanho marcado ao voltar pra página (restauração de formulário) */
  function resetPending() {
    document.querySelectorAll('product-info[data-tw-size="pending"]').forEach((info) => {
      info.querySelectorAll(SIZE + ' input:checked').forEach((i) => {
        i.checked = false;
      });
    });
  }

  /* Faixa do kit: "Ver o que combina" desce até a faixa "Combina com" da própria página */
  function initAnchors() {
    document.querySelectorAll('a[data-tw-anchor]').forEach((a) => {
      const target = document.getElementById(a.dataset.twAnchor);
      if (target) a.setAttribute('href', '#' + target.id);
    });
  }

  /* ---------- Barra fixa de compra ----------
     Pela posição a cada rolagem (1 leitura por quadro), não por IntersectionObserver: num salto de rolagem (voltar ao
     topo, âncora) o botão não chega a cruzar a tela e o observer não dispara.
     Regra (30/set, opção A aprovada pelo Pedro, "no celular"): a barra aparece sempre que o COMPRAR não está INTEIRO
     na tela.
       abaixo  (chegada: no celular ele fica ~1,3 mil px pra baixo) → barra embaixo, só abaixo de 990 px;
       acima   (já passou) → barra embaixo no celular, faixa em cima no computador, como antes.
     Com o COMPRAR inteiro à vista, a barra some. No celular a troca é no mesmo lugar: enquanto ele sobe por trás da
     barra (64 px, mais alta que o botão de 52), ela o cobre inteiro; quando ele fica inteiro, ela some.
     Computador sem barra na chegada (conferência 30/set): em 1366×768 o COMPRAR já chega à vista, e num notebook mais
     baixo (1366×657, o 1366×768 real com a barra do navegador) os tamanhos chegam à vista com o COMPRAR logo abaixo.
     Um cartão embaixo cobria justo a fileira de tamanhos, e sem cobri-la só caberia numa faixa de ~36 px de rolagem
     (piscava).
     O botão real é buscado de novo a cada leitura (a Rise pode trocar o nó na troca de variante).
     Os ouvintes de rolagem ficam presos num AbortController por barra: recarregar a seção no editor solta os antigos. */
  const ctrls = new Map();
  function initSticky(bar) {
    if (bar.dataset.twReady) return;
    bar.dataset.twReady = '1';
    const real = () => document.getElementById(bar.dataset.target);
    if (!real()) return;
    const old = ctrls.get(bar.id);
    if (old) old.abort();
    const ctrl = new AbortController();
    ctrls.set(bar.id, ctrl);
    const update = () => {
      if (!bar.isConnected) {
        ctrl.abort();
        return;
      }
      const target = real();
      const r = target ? target.getBoundingClientRect() : null;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      // botão fora do layout (esgotado sem botão, modal fechado): rect zerado, sem barra
      const above = !!r && r.height > 0 && r.bottom < 0;
      const below = !!r && r.height > 0 && r.bottom > vh && !desk.matches;
      const show = above || below;
      if (bar.hidden !== show) return;
      bar.hidden = !show;
      document.body.classList.toggle('rx-sticky-visible', show);
    };
    let queued = false;
    const onScroll = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        update();
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true, signal: ctrl.signal });
    window.addEventListener('resize', onScroll, { signal: ctrl.signal });
    // fonte e fotos podem mexer a página depois do 1º cálculo, sem evento de rolagem
    window.addEventListener('load', onScroll, { signal: ctrl.signal });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(onScroll);
    update();
    const btn = bar.querySelector('.rx-sticky__button');
    if (btn) btn.addEventListener('click', () => { const t = real(); if (t) t.click(); });
    const info = document.querySelector('product-info[data-section="' + bar.id.replace('StickyAtc-', '') + '"]');
    if (info) syncSticky(info);
  }

  function initAll() {
    resetPending();
    initAnchors();
    document.querySelectorAll('.rx-sticky[data-target]').forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
